const MarkdownStrong = ({ ...props }) => {
  return <span className="font-bold" {...props} />;
};

export default MarkdownStrong;
